import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PRINT_PAGE_SIZE_OPTIONS } from 'constants/printPageSize';
import {
  getPreferredPrintPageSize,
  savePreferredPrintPageSize,
} from 'utils/printPageSize';

/**
 * Print button that lets the user pick the paper size (4×6" thermal label
 * or A4). The last used size for `storageKey` is remembered and shown checked.
 * Pass `label` to show text next to the icon (icon-only by default).
 */
const PrintSizeDropdown = ({
  storageKey,
  onPrint,
  variant = 'falcon-default',
  size = 'sm',
  className = '',
  title = 'Print',
  label = null,
}) => {
  const [preferred, setPreferred] = useState(() =>
    getPreferredPrintPageSize(storageKey),
  );

  const handleSelect = pageSize => {
    savePreferredPrintPageSize(storageKey, pageSize);
    setPreferred(pageSize);
    onPrint(pageSize);
  };

  return (
    <Dropdown
      className={`d-inline-block ${className}`}
      // stop the click from bubbling to row-level handlers in tables
      onClick={e => e.stopPropagation()}
    >
      <Dropdown.Toggle variant={variant} size={size} title={title}>
        <FontAwesomeIcon icon="file-alt" />
        {label && <span className="ms-1">{label}</span>}
      </Dropdown.Toggle>
      <Dropdown.Menu align="end">
        <Dropdown.Header>Print size</Dropdown.Header>
        {PRINT_PAGE_SIZE_OPTIONS.map(option => (
          <Dropdown.Item
            key={option.value}
            onClick={() => handleSelect(option.value)}
            className="d-flex align-items-center"
          >
            <span className="me-2" style={{ width: '1em' }}>
              {option.value === preferred && (
                <FontAwesomeIcon icon="check" className="text-primary" />
              )}
            </span>
            <span>
              <div>{option.label}</div>
              <div className="fs-10 text-600">{option.description}</div>
            </span>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

PrintSizeDropdown.propTypes = {
  storageKey: PropTypes.string.isRequired,
  onPrint: PropTypes.func.isRequired,
  variant: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  label: PropTypes.node,
};

export default PrintSizeDropdown;
